<mat-dialog-content>
    <title mat-dialog-title>Add Player</title>
    <mat-card-content>
        <form [formGroup]="playerGroup" (ngSubmit)="addPlayer()">
                <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                    <mat-label>Name</mat-label>
                    <input matInput [formControl]="playerGroup.controls.nameControl">
                </mat-form-field>
                <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                    <mat-label>Nationality</mat-label>
                    <mat-select [formControl]="playerGroup.controls.nationalityControl">
                        <mat-option *ngFor="let nationality of nationalities" [value]="nationality.code"><img class="country-flag-dropdown" [src]="'https://assets.liumex.com/resources/esportsms/content/f/' + nationality.code + '.svg'">{{ nationality.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                    <mat-label>Languages</mat-label>
                    <mat-select [formControl]="playerGroup.controls.languagesControl" multiple>
                        <mat-option *ngFor="let language of languages" [value]="language.code">{{ language.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-card-actions>
                    <button mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!playerGroup.valid" color="accent"><mat-icon>add_box</mat-icon>Add</button>
                    <button mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
                </mat-card-actions>
        </form>
    </mat-card-content>
</mat-dialog-content> 